import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, Fragment as _Fragment, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@assets/images/digital/model_bottom.png';
const _withScopeId = n => (_pushScopeId("data-v-4e129567"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "file-box",
  ref: "imgBox"
};
const _hoisted_2 = {
  class: "img-box"
};
const _hoisted_3 = {
  key: 0,
  class: "img"
};
const _hoisted_4 = ["src"];
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "model-bottom",
  src: _imports_0
}, null, -1));
const _hoisted_6 = {
  class: "link-btn"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_CompModel = _resolveComponent("CompModel");
  const _component_CompTech = _resolveComponent("CompTech");
  return _openBlock(), _createElementBlock("div", null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [$data.detail.nft_type == 1 ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createElementVNode("img", {
    class: "img-cont",
    src: _ctx.file.img
  }, null, 8, _hoisted_4)])) : $data.detail.nft_type == 2 ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 1
  }, [_hoisted_5, $data.glb_url ? (_openBlock(), _createBlock(_component_CompModel, {
    key: 0,
    modelUrl: $data.glb_url
  }, null, 8, ["modelUrl"])) : _createCommentVNode("", true)], 64)) : _createCommentVNode("", true)])], 512), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", {
    class: "open-btn",
    onClick: _cache[0] || (_cache[0] = (...args) => $options.goToLink && $options.goToLink(...args))
  }, "去APP内打开")]), _createVNode(_component_CompTech, {
    detail: $data.detail
  }, null, 8, ["detail"])]);
}